<script>
  import { Router, Link, Route, link, navigate } from "svelte-routing";
  import { onMount } from "svelte";

  const user = localStorage.getItem("us");

  onMount(() => {
    window.scrollTo(0, 0);
    if (user === null || user === "") {
      navigate("/login");
    }
  });
</script>

<svelte:head>
  <title>Privacy Policy | Veeranfashions</title>
</svelte:head>

<main class="main-wrapper">
  <!-- ...:::Start User Event Section:::... -->
  <div class="header-section">
    <div class="container">
      <!-- Start User Event Area -->
      <div class="header-area">
        <div class="header-top-area header-top-area--style-1">
          <ul class="event-list">
            <li class="list-item">
              <span
                onclick="goback()"
                area-label="mobile menu offcanvas svg icon"
                class="btn btn--size-33-33 btn--center btn--round btn--color-radical-red btn--bg-white btn--box-shadow main-menu offcanvas-toggle offside-menu"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-caret-left-fill"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="m3.86 8.753 5.482 4.796c.646.566 1.658.106 1.658-.753V3.204a1 1 0 0 0-1.659-.753l-5.48 4.796a1 1 0 0 0 0 1.506z"
                  />
                </svg>
              </span>
            </li>
            <li class="list-item">
              <h6 class="title text-center">Privacy statement</h6>
            </li>
            <li class="list-item">
              <ul class="list-child">
                <li class="list-item">
                  <span class="notch-bg" />

                  <Link
                    to="cart"
                    area-label="Cart"
                    class="btn btn--size-33-33 btn--center btn--round btn--color-radical-red btn--bg-white btn--box-shadow"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-cart-fill"
                      viewBox="0 0 16 16"
                    >
                      <path
                        d="M0 1.5A.5.5 0 0 1 .5 1H2a.5.5 0 0 1 .485.379L2.89 3H14.5a.5.5 0 0 1 .491.592l-1.5 8A.5.5 0 0 1 13 12H4a.5.5 0 0 1-.491-.408L2.01 3.607 1.61 2H.5a.5.5 0 0 1-.5-.5zM5 12a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm7 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm-7 1a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm7 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"
                      />
                    </svg>
                  </Link>
                </li>
                <li class="list-item">
                  <span class="notch-bg" />
                  <Link
                    to="settings"
                    area-label="Cart"
                    class="btn btn--size-33-33 btn--center btn--round btn--color-radical-red btn--bg-white btn--box-shadow"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-person-fill"
                      viewBox="0 0 16 16"
                    >
                      <path
                        d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"
                      />
                    </svg>
                  </Link>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
      <!-- End User Event Area -->
    </div>
  </div>
  <!-- ...:::End User Event Section:::... -->

  <!-- ...:::Start Whishlist Section:::... -->
  <div class="cart-section section-gap-top-30">
    <div class="container">
      <div class="cart-items-wrapper">
        <!-- Start Single Cart Item -->
        <div class="product-wrapper glass glass_bg">
          <div class="product-wrapper-content--4">
            <!-- Start Product Single Item -->
            <div class="single-product-item product-item--style-4">
              <div class="content">
                <div class="content--left">
                  <article class="container">
                    <div class="row justify-content-center">
                      <div
                        class="col-12 col-lg-12 p-4 bg-custom-animation2  text-color-white rounded"
                      >
                        <div>
                          <h4 class="title text-color-white">
                            <u>WHAT DO WE DO WITH YOUR INFORMATION?</u>
                          </h4>
                          <p class="text-justify">
                            When you purchase something from our store, as part
                            of the buying and selling process, we collect the
                            personal information you give us such as your name,
                            address and email address.<br /><br />
                            When you browse our store, we also automatically receive
                            your computer’s internet protocol (IP) address in order
                            to provide us with information that helps us learn about
                            your browser and operating system.<br /><br />
                            Email marketing (if applicable): With your permission,
                            we may send you emails about our store, new products
                            and other updates.<br /><br />
                          </p>
                          <hr />
                          <h4 class="title text-color-white"><u>CONSENT</u></h4>
                          <p class="text-justify">
                            How do you get my consent?<br />
                            When you provide us with personal information to complete
                            a transaction, verify your credit card, place an order,
                            arrange for a delivery or return a purchase, we imply
                            that you consent to our collecting it and using it for
                            that specific reason only.<br />
                            If we ask for your personal information for a secondary
                            reason, like marketing, we will either ask you directly
                            for your expressed consent, or provide you with an opportunity
                            to say no.<br />
                            How do I withdraw my consent?<br />
                            If after you opt-in, you change your mind, you may withdraw
                            your consent for us to contact you, for the continued
                            collection, use or disclosure of your information, at
                            anytime, by contacting us at veeranmenswear@gmail.com
                            .<br />
                          </p>
                          <hr />
                          <h4 class="title text-color-white">
                            <u>DISCLOSURE</u>
                          </h4>
                          <p class="text-justify">
                            We may disclose your personal information if we are
                            required by law to do so or if you violate our Terms
                            of Service.<br />
                          </p>
                          <hr />
                          <h4 class="title text-color-white"><u>PAYMENT</u></h4>
                          <p class="text-justify">
                            We use Razorpay for processing payments. We/Razorpay
                            do not store your card data on their servers. The
                            data is encrypted through the Payment Card Industry
                            Data Security Standard (PCI-DSS) when processing
                            payment. Your purchase transaction data is only used
                            as long as is necessary to complete your purchase
                            transaction. After that is complete, your purchase
                            transaction information is not saved.<br />
                            Our payment gateway adheres to the standards set by PCI-DSS
                            as managed by the PCI Security Standards Council, which
                            is a joint effort of brands like Visa, MasterCard, American
                            Express and Discover.<br />
                            PCI-DSS requirements help ensure the secure handling
                            of credit card information by our store and its service
                            providers.<br />
                            For more insight, you may also want to read terms and
                            conditions of razorpay on https://razorpay.com .<br
                            />
                          </p>
                          <hr />
                          <h4 class="title text-color-white">
                            <u>THIRD-PARTY SERVICES</u>
                          </h4>
                          <p class="text-justify">
                            In general, the third-party providers used by us
                            will only collect, use and disclose your information
                            to the extent necessary to allow them to perform the
                            services they provide to us.<br />
                            However, certain third-party service providers, such
                            as payment gateways and other payment transaction processors,
                            have their own privacy policies in respect to the information
                            we are required to provide to them for your purchase-related
                            transactions.<br />
                            For these providers, we recommend that you read their
                            privacy policies so you can understand the manner in
                            which your personal information will be handled by these
                            providers.<br />
                            In particular, remember that certain providers may be
                            located in or have facilities that are located a different
                            jurisdiction than either you or us. So if you elect to
                            proceed with a transaction that involves the services
                            of a third-party service provider, then your information
                            may become subject to the laws of the jurisdiction(s)
                            in which that service provider or its facilities are
                            located.<br />
                            Once you leave our store’s website or are redirected
                            to a third-party website or application, you are no longer
                            governed by this Privacy Policy or our website’s Terms
                            of Service. <br />
                            <b>Links</b><br />
                            When you click on links on our store, they may direct
                            you away from our site. We are not responsible for the
                            privacy practices of other sites and encourage you to
                            read their privacy statements.<br />
                          </p>
                          <hr />
                          <h4 class="title text-color-white">
                            <u>SECURITY</u>
                          </h4>
                          <p class="text-justify">
                            To protect your personal information, we take
                            reasonable precautions and follow industry best
                            practices to make sure it is not inappropriately
                            lost, misused, accessed, disclosed, altered or
                            destroyed.<br />
                          </p>
                          <hr />
                          <h4 class="title text-color-white"><u>COOKIES</u></h4>
                          <p class="text-justify">
                            We use cookies to maintain session of your user. It
                            is not used to personally identify you on other
                            websites.<br />
                          </p>
                          <hr />
                          <h4 class="title text-color-white">
                            <u>AGE OF CONSENT</u>
                          </h4>
                          <p class="text-justify">
                            By using this site, you represent that you are at
                            least the age of majority in your state or province
                            of residence, or that you are the age of majority in
                            your state or province of residence and you have
                            given us your consent to allow any of your minor
                            dependents to use this site.<br />
                          </p>
                          <hr />
                          <h4 class="title text-color-white">
                            <u>CHANGES TO THIS PRIVACY POLICY</u>
                          </h4>
                          <p class="text-justify">
                            We reserve the right to modify this privacy policy
                            at any time, so please review it frequently. Changes
                            and clarifications will take effect immediately upon
                            their posting on the website. If we make material
                            changes to this policy, we will notify you here that
                            it has been updated, so that you are aware of what
                            information we collect, how we use it, and under
                            what circumstances, if any, we use and/or disclose
                            it.<br />
                            If our store is acquired or merged with another company,
                            your information may be transferred to the new owners
                            so that we may continue to sell products to you.<br
                            />
                          </p>
                          <hr />
                          <h4 class="title text-color-white">
                            <u>QUESTIONS AND CONTACT INFORMATION</u>
                          </h4>
                          <p class="text-justify">
                            If you would like to: access, correct, amend or
                            delete any personal information we have about you,
                            register a complaint, or simply want more
                            information contact our Privacy Compliance Officer
                            at veeranmenswear@gmail.com or by mail at
                          </p>
                          <br /><br />
                          <ul>
                            <b>
                              VEERAN ENTERPRISE .<br />
                              80/1 T.PET ROAD<br />
                              NEAR L.G HOSPITAL<br />
                              MUSIRI (po) &amp; (TK)<br />
                              TRICHY (DT)<br />
                              Pincode 621211<br />
                            </b>
                          </ul>
                          <p />
                        </div>
                      </div>
                    </div>
                  </article>
                </div>
              </div>
              <a href="#?" aria-label="Cart" class="cart-link"
                ><i class="icon icon-carce-x-circle" /></a
              >
            </div>
            <!-- ENd Product Single Item -->
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- ...:::End Whishlist Section:::... -->

  <!-- ...:::Start User Event Section:::... -->
  <div class="user-event-section">
    <!-- Start User Event Area -->
    <div class="col pos-relative">
      <div class="user-event-area">
        <div class="nav">
          <Link to="/" class="nav__link">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="currentColor"
              class="bi bi-house-fill"
              viewBox="0 0 16 16"
            >
              <path
                fill-rule="evenodd"
                d="m8 3.293 6 6V13.5a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 13.5V9.293l6-6zm5-.793V6l-2-2V2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5z"
              />
              <path
                fill-rule="evenodd"
                d="M7.293 1.5a1 1 0 0 1 1.414 0l6.647 6.646a.5.5 0 0 1-.708.708L8 2.207 1.354 8.854a.5.5 0 1 1-.708-.708L7.293 1.5z"
              />
            </svg>
            <br />
            <h6>Home</h6>
          </Link>
          <Link to="/wishlist" class="nav__link">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="currentColor"
              class="bi bi-heart-fill"
              viewBox="0 0 16 16"
            >
              <path
                fill-rule="evenodd"
                d="M8 1.314C12.438-3.248 23.534 4.735 8 15-7.534 4.736 3.562-3.248 8 1.314z"
              />
            </svg>
            <br />
            <h6>Wishlist</h6>
          </Link>
          <Link to="/shop" class="nav__link">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="currentColor"
              class="bi bi-grid-fill"
              viewBox="0 0 16 16"
            >
              <path
                d="M1 2.5A1.5 1.5 0 0 1 2.5 1h3A1.5 1.5 0 0 1 7 2.5v3A1.5 1.5 0 0 1 5.5 7h-3A1.5 1.5 0 0 1 1 5.5v-3zm8 0A1.5 1.5 0 0 1 10.5 1h3A1.5 1.5 0 0 1 15 2.5v3A1.5 1.5 0 0 1 13.5 7h-3A1.5 1.5 0 0 1 9 5.5v-3zm-8 8A1.5 1.5 0 0 1 2.5 9h3A1.5 1.5 0 0 1 7 10.5v3A1.5 1.5 0 0 1 5.5 15h-3A1.5 1.5 0 0 1 1 13.5v-3zm8 0A1.5 1.5 0 0 1 10.5 9h3a1.5 1.5 0 0 1 1.5 1.5v3a1.5 1.5 0 0 1-1.5 1.5h-3A1.5 1.5 0 0 1 9 13.5v-3z"
              />
            </svg>
            <br />
            <h6>Shop</h6>
          </Link>
          
          <Link to="/orders" class="nav__link">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="currentColor"
              class="bi bi-box-seam-fill"
              viewBox="0 0 16 16"
            >
              <path
                fill-rule="evenodd"
                d="M15.528 2.973a.75.75 0 0 1 .472.696v8.662a.75.75 0 0 1-.472.696l-7.25 2.9a.75.75 0 0 1-.557 0l-7.25-2.9A.75.75 0 0 1 0 12.331V3.669a.75.75 0 0 1 .471-.696L7.443.184l.01-.003.268-.108a.75.75 0 0 1 .558 0l.269.108.01.003 6.97 2.789ZM10.404 2 4.25 4.461 1.846 3.5 1 3.839v.4l6.5 2.6v7.922l.5.2.5-.2V6.84l6.5-2.6v-.4l-.846-.339L8 5.961 5.596 5l6.154-2.461L10.404 2Z"
              />
            </svg>
            <br />
            <h6>Orders</h6>
          </Link>
          
          <Link to="/settings" class="nav__link">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="currentColor"
              class="bi bi-gear-fill"
              viewBox="0 0 16 16"
            >
              <path
                d="M9.405 1.05c-.413-1.4-2.397-1.4-2.81 0l-.1.34a1.464 1.464 0 0 1-2.105.872l-.31-.17c-1.283-.698-2.686.705-1.987 1.987l.169.311c.446.82.023 1.841-.872 2.105l-.34.1c-1.4.413-1.4 2.397 0 2.81l.34.1a1.464 1.464 0 0 1 .872 2.105l-.17.31c-.698 1.283.705 2.686 1.987 1.987l.311-.169a1.464 1.464 0 0 1 2.105.872l.1.34c.413 1.4 2.397 1.4 2.81 0l.1-.34a1.464 1.464 0 0 1 2.105-.872l.31.17c1.283.698 2.686-.705 1.987-1.987l-.169-.311a1.464 1.464 0 0 1 .872-2.105l.34-.1c1.4-.413 1.4-2.397 0-2.81l-.34-.1a1.464 1.464 0 0 1-.872-2.105l.17-.31c.698-1.283-.705-2.686-1.987-1.987l-.311.169a1.464 1.464 0 0 1-2.105-.872l-.1-.34zM8 10.93a2.929 2.929 0 1 1 0-5.86 2.929 2.929 0 0 1 0 5.858z"
              />
            </svg>
            <br />
            <h6>Settings</h6>
          </Link>
        </div>
      </div>
    </div>
    <!-- End User Event Area -->
  </div>
  <!-- ...:::End User Event Section:::... -->

  <footer class="footer-section" />
</main>
